export default "__VITE_ASSET__B2rTCUjq__"